export default __webpack_public_path__ + "static/media/edit_icon.fe854d71.svg";